import Cache from 'root/cache';

// return inbox notification settings for projects
export function getProjects() {
    var saved_filters = Cache.app.getUserSetting('inbox_filter', false);
    var saved_projects = {};

    try {
        saved_filters = JSON.parse(saved_filters);
        saved_projects = typeof saved_filters.projects === 'object' ? saved_filters.projects : saved_projects;
    } catch (e) {
    }

    return saved_projects;
}